module.exports = "<div class=\"modal-header\">\n    <h3 class=\"modal-title\">{{title}}</h3>\n</div>\n<div class=\"modal-body\">\n    {{message}}\n</div>\n<div class=\"modal-footer\">\n    <button class=\"btn btn-default\" ng-click=\"cancel()\" data-i18n=\"common.buttons.cancel\">Cancel</button>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/ui/modules/dc-ui/dc-modal/primaryTemplate.tpl.html
// module id = 488
// module chunks = 12